(($) ->

  window.Loader = do () ->
    show: (options) ->
      options = options || {}

      loader_class = 'loader'
      if options.target?
        target = options.target
        loader_class += ' loader_inside'
      else
        target = '.main'

      loader_body = "<i class='fa fa-circle-o-notch fa-spin'></i>";
      if options.text
        loader_body = """
          <span class='loader_text'>#{options.text}</span>
          <br>
          #{loader_body}
        """

      buttons = options.buttons || []
      if buttons.length
        loader_body += "<br>"
        if 'cancel' in buttons
          loader_body += """
            <a href='javascript:;' class='btn btn-link' data-fullpage-loader-action='cancel'>
              <i class='fa fa-times'></i> #{__('cancel')}
            </a>
          """

      loader = $ """
        <div class='#{loader_class}' data-fullpage-loader data-target="#{target}">
          <div class='loader_content'>#{loader_body}</div>
        </div>
      """

      Loader.hide(options)
      $(target).prepend loader
      loader_content = loader.find('.loader_content')
      margin_left = loader_content.width() / 2
      margin_top = loader_content.height() / 2
      min_top = $(window).height() / 2 - $('.navbar.navbar-default').height()
      if margin_top > min_top
        margin_top = min_top

      loader_content.css {
        'margin-left': -margin_left,
        'margin-top': -margin_top
      }

    hide: (options) ->
      options = options || {}
      if options.target?
        target = options.target
      else
        target = '.main'

      loader = $('[data-fullpage-loader][data-target="' + target + '"]')
      if loader.length
        loader.remove()

    toggle: (options) ->
      options = options || {}
      if options.target?
        target = options.target
      else
        target = '.main'

      loader = $('[data-fullpage-loader][data-target="' + target + '"]')
      if loader.length
        @hide(options)
      else
        @show(options)

) window.jQuery